export default __webpack_public_path__ + "static/media/placeholder-home (3).fec8f4b3.png";